/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 零元购支付
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class ZeroBuyParams {
  constructor(
    public orderId?: string,
    public orderType?:
      | "RECHARGE"
      | "SHOW"
      | "COMMODITY"
      | "VIDEO"
      | "ACTIVITYAPPLY"
  ) {}
}

export default async function (
  params: ZeroBuyParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/payment/pay/zero`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
